module.exports = __webpack_public_path__ + "static/topBg-f74034cd7c2fb1325823d4ecac8aaa64.jpg";